import InspectionHistoryContainer from './InspectionsHistoryContainer'
export default InspectionHistoryContainer
